export const hasNewAuthSessionCookieName = 'newAuth_hasSession'

export const loginCompletedTriggerCookieName = 'na_lc'

export const AUTH_SESSION_PREFIX = '__session'
